import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import CustomDropdown from '@components/CustomDropdown';
import ModalContainer from '@components/modals/ModalContainer';
import ModalHeader from '@components/modals/ModalHeader';

import UploadKeyProduct from '@features/supplier/component/UploadKeyProduct';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import {
	addAccessories,
	addTrims,
	getTrimsAndAccessoriesCategories,
	getTrimsAndAccessoriesQuality
} from '@services/supplierOnboardingService';

import { capitalizeFirstLetter } from '@utils/Util';

const KeyProductTrimsAndAccessories = ({ onClose, onSuccess, parameterType }) => {
	const [documentList, setDocumentList] = useState([]);
	const [categories, setCategories] = useState([]);
	const [materialQuality, setMaterialQuality] = useState([]);
	const { id } = useParams();
	const dispatch = useDispatch();
	const isLoading = useSelector((store) => store.loaderStore);
	const [selectedCategory, setSelectedCategory] = useState({});
	const [selectedMaterial, setSelectedMaterial] = useState({});
	const [errors, setErrors] = useState({});
	const [inputData, setInputData] = useState({});

	useEffect(() => {
		(async () => {
			const materialQualityList = await getTrimsAndAccessoriesQuality('MATERIAL_QUALITY');
			setMaterialQuality(materialQualityList?.map((item) => ({ id: item.id, value: item.text })));
			const categoryList = await getTrimsAndAccessoriesCategories(true, parameterType);
			setCategories(categoryList);
		})();
	}, []);

	const onItemClick = (item) => {
		if (item?.title === 'Category') {
			setSelectedCategory(item);
		}
		if (item?.title === 'Material') {
			setSelectedMaterial(item);
		}
	};

	const isValid = () => {
		let err = {};
		if (!selectedCategory?.id) {
			err['categoryError'] = 'Product category is required!';
		}
		setErrors(err);
		return Object.keys(err).length <= 0;
	};

	const onSave = async () => {
		if (isValid()) {
			try {
				dispatch(openLoader());
				let selectedImageIds = documentList.map((item) => item.id);
				let postData = {
					trimsAndBrandingRequest: {
						categoryId: selectedCategory.id,
						materialQualityTagRequest: {
							id: selectedMaterial.id,
							text: selectedMaterial.value
						},
						documentIdList: selectedImageIds,
						materialType: parameterType === 'ACCESSORIES' ? 'BRANDING' : 'TRIMS',
						addType: 'Add'
					},
					supplierMaterialRequest: {
						price: inputData.price,
						supplierId: id,
						requestedPage: 'SUPPLIER'
					}
				};

				if (parameterType === 'ACCESSORIES') {
					await addAccessories(postData);
				} else {
					await addTrims(postData);
				}
				await onSuccess();
				dispatch(closeLoader());
			} catch {
				dispatch(closeLoader());
			}
		}
	};

	const handleChange = (e) => {
		const { name, value } = e.target;
		setInputData((prev) => ({
			...prev,
			[name]: value
		}));
	};

	return (
		<ModalContainer className="products-upload-modal">
			<div className="common-popup">
				<ModalHeader
					title={`Your Key Product (${capitalizeFirstLetter(parameterType)})`}
					onClose={onClose}
				/>
				<div className="common-popup-body">
					<div className="row">
						<UploadKeyProduct
							fieldName="materialsUpload"
							setDocumentList={setDocumentList}
							documentList={documentList}
						/>
						<div className="col-md-12 pr-2">
							<div className="form-group">
								<div className="select-component">
									<label htmlFor="collection">Product Category*</label>
									<CustomDropdown
										type="addItem"
										title={'Category'}
										isAddNew={false}
										onItemClick={onItemClick}
										items={categories}
										selectedItem={selectedCategory.value}
									/>
								</div>
								{errors?.categoryError && <p className="error">{errors.categoryError}</p>}
							</div>
						</div>
						<div className="col-md-6 pr-2">
							<div className="form-group">
								<div className="select-component">
									<label htmlFor="collection">Material Quality</label>
									<CustomDropdown
										type="addItem"
										title={'Material'}
										isAddNew={false}
										onItemClick={onItemClick}
										items={materialQuality}
										selectedItem={selectedMaterial.value}
									/>
								</div>
							</div>
						</div>
						<div className="col-md-6 pr-2">
							<div className="form-group">
								<label htmlFor="collection">Price</label>
								<input
									type="text"
									value={inputData?.price || ''}
									name="price"
									onChange={handleChange}
								/>
							</div>
						</div>
					</div>
				</div>
				<div className="modal-footer">
					<div className="footer-buttons text-right">
						<button className="button gray-outline size32" onClick={onClose}>
							Cancel
						</button>
						<button disabled={isLoading} className="button size32 ml-2" onClick={() => onSave()}>
							Submit
						</button>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default KeyProductTrimsAndAccessories;
